
import { Text } from "../../components/texts/text";
import Title from "../../components/texts/title";
import { _sizeHeading, _sizeText } from "../../core/core";
import { useOrder } from '../../entities/order/context/OrderContext';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../../shared/components/ui/accordion";
import "./faq.css";

interface FaqProps {
}

export const Faq = ({
}: FaqProps) => {
    const { service } = useOrder();
    if (!service) {
        return null;
    }
    return (
        <div className="faq-new">
            <div className="howwork-title">

                <Title type={_sizeHeading.h2_2}>
                    Часто спрашивают
                </Title>
            </div>
            <Accordion
                type="single"
                collapsible
                className="faq-block"
                defaultValue="item-1"
            >
                {service?.faq.map((question, index) => (
                    <>
                        <AccordionItem value={`item-${index}`} className="faq-item">
                            <AccordionTrigger>
                                <Text size={_sizeText.mbold}>{question.question}</Text>
                            </AccordionTrigger>
                            <AccordionContent className="text-balance">
                                <Text size={_sizeText.m}>{question.answer}</Text>
                            </AccordionContent>
                        </AccordionItem>
                    </>
                ))}
            </Accordion>
        </div>
    );
};